
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","viewBox":"0 0 52 52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.7658 0C11.5366 0 0 11.5396 0 25.7724C0 42.6859 18.6668 54.5061 25.7658 51.5448C30.7706 49.4563 28.1217 40.7907 36.0122 33.6899C42.9616 27.4494 49.6555 29.9805 51.5315 25.7724C54.5419 18.9895 42.7061 0 25.7658 0ZM42.463 26.1278C38.1313 26.1839 34.0614 27.892 30.9887 30.9718C27.9035 34.0577 26.1958 38.1412 26.1459 42.4864H25.8592C25.8094 38.1412 24.1016 34.0577 21.0165 30.9718C17.95 27.8983 13.8739 26.1839 9.54218 26.1278V25.841C13.8739 25.7849 17.9438 24.0767 21.0165 20.997C24.0892 17.9297 25.8031 13.8588 25.8592 9.51972H26.1397C26.1958 13.8525 27.9035 17.9235 30.9825 20.997C34.0552 24.0767 38.1313 25.7849 42.463 25.841V26.1278Z","fill":"url(#paint0_linear_3295_14812)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_3295_14812","x1":"0","y1":"26.0031","x2":"52.0052","y2":"26.0031","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0.04","stop-color":"#FFCCF2"}}),_c('stop',{attrs:{"offset":"0.16","stop-color":"#C8A2F8"}}),_c('stop',{attrs:{"offset":"0.25","stop-color":"#A487FD"}}),_c('stop',{attrs:{"offset":"0.3","stop-color":"#967CFF"}}),_c('stop',{attrs:{"offset":"0.51","stop-color":"#2A47FF"}}),_c('stop',{attrs:{"offset":"0.61","stop-color":"#0033FF"}}),_c('stop',{attrs:{"offset":"0.85","stop-color":"#0600AB"}}),_c('stop',{attrs:{"offset":"0.99","stop-color":"#171E55"}})])])])
          )
        }
      }
    